import InputRadioGroup from '@pretto/bricks/components/form/InputRadioGroup'
import { g } from '@pretto/bricks/components/layout'
import * as typo from '@pretto/bricks/core/typography'
import styled from 'styled-components'

export const Radio = styled(InputRadioGroup)``
export const Title = styled.div`
  ${typo.headline16};
  margin-bottom: ${g(1)};
`
